(() => {
  const root = document.documentElement;
  const KEY = 'nn-shop-view';

  const apply = (view) => {
    const isList = view === 'list';
    root.classList.toggle('nn-view-list', isList);
    document.querySelectorAll('[data-nn-view]').forEach((btn) => {
      const active = btn.getAttribute('data-nn-view') === (isList ? 'list' : 'grid');
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  apply(window.localStorage.getItem(KEY) || 'grid');

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-nn-view]');
    if (!btn) return;
    const view = btn.getAttribute('data-nn-view');
    window.localStorage.setItem(KEY, view);
    apply(view);
  });
})();
